<div class="dashboard-container">
  <div class="sticky-header">
    <h1 class="dashboard-title">Session Inspector</h1>
    <div class="selector-wrapper">
      <div class="filter-group">
        <p-select
          [options]="orgOptions()"
          [ngModel]="selectedOrg()"
          (ngModelChange)="selectedOrg.set($event)"
          optionLabel="name"
          placeholder="All Organizations"
          [showClear]="true"
          [filter]="true"
          filterBy="name"
          (onChange)="onFilterChange()"
          styleClass="w-15rem"
        ></p-select>

        <p-select
          [options]="userOptions()"
          [ngModel]="selectedUser()"
          (ngModelChange)="selectedUser.set($event)"
          optionLabel="email"
          placeholder="All Users"
          [showClear]="true"
          [filter]="true"
          [filterPlaceholder]="userFilterPlaceholder()"
          filterBy="email,firstName,lastName"
          (onFilter)="onUserFilter($event)"
          (onChange)="onUserFilterChange()"
          styleClass="w-15rem"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption>
            @if (selectedOption) {
              <div class="flex align-items-center gap-2">
                <div>{{ getUserDisplayName(selectedOption) }}</div>
              </div>
            }
          </ng-template>
          <ng-template let-user pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ getUserDisplayName(user) }}</div>
            </div>
          </ng-template>
        </p-select>

        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [ngModel]="textSearch()"
            (ngModelChange)="textSearch.set($event); onSearchInput()"
            placeholder="Search title, org, ID..."
            styleClass="w-16rem"
          />
        </span>

        @if (uiState.sessionOrgId() || uiState.sessionUserId() || textSearch()) {
          <p-button
            label="Clear"
            icon="pi pi-filter-slash"
            [text]="true"
            severity="secondary"
            (click)="clearFilters()"
          ></p-button>
        }
      </div>

      <app-date-range-selector
        [selectedPeriod]="selectedPeriod()"
        [startDate]="startDate()"
        [endDate]="endDate()"
        [includeWeek]="true"
        (periodChange)="onPeriodChange($event)"
        (dateRangeChange)="onDateRangeChange($event)"
      />
    </div>
  </div>

  @if (sessionsService.errorMessage(); as error) {
    <app-error-banner [message]="error" />
  }

  <div class="dashboard-grid">
    <div class="card-wrapper full-width">
      <p-card>
        <p-table
          #sessionsTable
          [value]="sessionsService.sessions()"
          [paginator]="true"
          [rows]="20"
          [totalRecords]="sessionsService.total()"
          [lazy]="true"
          [lazyLoadOnInit]="false"
          [first]="firstRow()"
          (onPage)="firstRow.set($event.first)"
          (onLazyLoad)="loadData($event)"
          styleClass="p-datatable-striped"
          [tableStyle]="{ 'min-width': '60rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="createdAt">Date <p-sortIcon field="createdAt" /></th>
              <th pSortableColumn="type">Type <p-sortIcon field="type" /></th>
              <th pSortableColumn="meetingTitle">
                Title / Subtype <p-sortIcon field="meetingTitle" />
              </th>
              <th>Organisation</th>
              <th>User</th>
              <th pSortableColumn="status">Status <p-sortIcon field="status" /></th>
              <th pSortableColumn="score">Score/Duration <p-sortIcon field="score" /></th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-session>
            <tr (click)="openDetail(session)" class="clickable-row">
              <td>{{ session.createdAt | date: 'medium' }}</td>
              <td>
                <p-tag
                  [value]="session.type"
                  [severity]="session.type === 'LIVE' ? 'warn' : 'info'"
                ></p-tag>
              </td>
              <td>{{ session.meetingTitle || session.subType }}</td>
              <td>
                @if (session.user) {
                  <a
                    class="link-cell"
                    tabindex="0"
                    role="link"
                    (click)="openOrg(session); $event.stopPropagation()"
                    (keydown.enter)="openOrg(session); $event.stopPropagation()"
                  >
                    {{ session.user.organisation }}
                  </a>
                } @else {
                  <span class="text-500">—</span>
                }
              </td>
              <td>
                @if (session.user) {
                  <div class="font-medium">{{ session.user.name }}</div>
                  <div class="text-xs text-500">{{ session.user.email }}</div>
                } @else {
                  <span class="text-500">—</span>
                }
              </td>
              <td>
                <p-tag
                  [value]="session.status"
                  [severity]="getStatusSeverity(session.status)"
                ></p-tag>
              </td>
              <td>
                @if (session.score !== undefined) {
                  <span class="font-bold text-primary">{{ session.score }}/10</span>
                }
                @if (session.duration !== undefined) {
                  <span class="ml-2 text-500">{{ session.duration / 60 | number: '1.0-0' }}m</span>
                }
              </td>
              <td>
                <p-button icon="pi pi-eye" [rounded]="true" [text]="true"></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="text-center p-4">
                No sessions found for the selected criteria.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </div>
</div>
